import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CotizacionColectivo } from '../../models/cotizacion-colectivo/cotizacion-colectivo.model'
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root'
})
export class CotizacionColectivoService {

  private apiUrl = `${environment.HOST}${URL_MAP.API.COTIZACIONCOLECTIVO}`;

  constructor(private http: HttpClient) {}

  guardar(data: CotizacionColectivo): Observable<CotizacionColectivo> {
    return this.http.post<CotizacionColectivo>(
      `${this.apiUrl}/guardar`,
      data
    );
  }

  actualizar(idCotizacion: number, data: CotizacionColectivo): Observable<CotizacionColectivo> {
    return this.http.put<CotizacionColectivo>(
      `${this.apiUrl}/${idCotizacion}`,
      data
    );
  }
  
  obtenerPorCotizacion(idCotizacion: number): Observable<CotizacionColectivo[]> {
    return this.http.get<CotizacionColectivo[]>(`${this.apiUrl}/${idCotizacion}`);
  }

  buscarEmpresaPorNit(nit: string, idAsesor: number) {
    return this.http.get<any>(
      `${this.apiUrl}/empresa/${nit}?idAsesor=${idAsesor}`,
    );
  }

}